import { host } from '@/services/HostAPI'

const timerInterval = 1000 * 60 * 5
var intervalId = null

const isWithinDaylightHours = () => {
  const hourOfDay = new Date().getHours()
  return hourOfDay >= 4 && hourOfDay <= 21
}

const baseRq = {
  Info: {
    ScheduledServiceId: null,
    ActivityDescription: 'Checkin'
  }
}

const start = () => {
  if (intervalId === null) {
    intervalId = setInterval(() => {
      if (isWithinDaylightHours()) {
        log({ ...baseRq })
      }
    }, timerInterval)
  }
}

const stop = () => {
  if (intervalId !== null) {
    clearInterval(intervalId)
    intervalId = null
  }
}

const log = rq => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(position =>
      logCurrentPosition(position, rq)
    )
  }
}

const logCurrentPosition = (position, rq) => {
  rq.Info.LatLong = {
    Latitude: position.coords.latitude,
    Longitude: position.coords.longitude
  }

  host.geoLocation.addLog(rq)
}

const geoLocationLogService = {
  start: start,
  stop: stop,
  log: log
}

export { geoLocationLogService }
